//COMPONENTS
import { getChildsTest } from "./modules/test";
import { getChildsAos } from "./modules/Aos";
import { getHeaderHandlers } from "./modules/Header";
import { Loader } from "./components/Loader";
import "../sass/main.scss";

window.addEventListener('load', ()=>{
    setTimeout(()=>{
        Loader();
        getChildsAos();
        getChildsTest();
        getHeaderHandlers();
    },1500);
});